import styled, { css } from "styled-components"
import { Button } from "buoy-core"
import Text from "../../../common/components/Text"

const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${props => (props.first ? 0 : "1rem")};
`

const OptionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
`

const Option = styled(Button).attrs({
  color: "primary",
})`
  margin: 0 12px 12px 0;
  max-width: 100%;
  ${props =>
    props.disable
      ? css`
          opacity: 0.5;
          cursor: not-allowed;
          pointer-events: none;
        `
      : ""};
`

const OptionLabel = styled(Text)`
  margin-bottom: 16px;
  ${props =>
    props.disable
      ? css`
          opacity: 0.5;
        `
      : ""};
`

OptionLabel.defaultProps = {
  block: true,
  fontWeight: "regular",
}

export { QuestionContainer, OptionContainer, Option, OptionLabel }



// WEBPACK FOOTER //
// ./assets/feedback/components/tagging/common.js